// Composable for consistent date/time formatting

interface FirestoreTimestamp {
  seconds: number;
  nanoseconds?: number;
}

interface OldFirestoreTimestamp {
  _seconds: number;
  _nanoseconds?: number;
}

type DateTimeInput = Date | string | number | FirestoreTimestamp | OldFirestoreTimestamp | null | undefined;

function isFirestoreTimestamp(val: any): val is FirestoreTimestamp {
  return val && typeof val === "object" && typeof val.seconds === "number";
}

function isOldFirestoreTimestamp(val: any): val is OldFirestoreTimestamp {
  return val && typeof val === "object" && typeof val._seconds === "number";
}

export function formatDateTime(value: DateTimeInput, type?: string): string {
  try {
    if (value === undefined || value === null || value === "") return "";

    // Check if it is a simple HH:MM or HH:MM:SS time string
    if (typeof value === "string" && value.includes(":") && !value.includes("-") && !value.includes("T")) {
      const parts = value.split(":");
      if (parts.length >= 2) {
        const hours = parseInt(parts[0], 10);
        const minutes = parseInt(parts[1], 10);
        if (!isNaN(hours) && !isNaN(minutes) && hours >= 0 && hours < 24 && minutes >= 0 && minutes < 60) {
          const dateObj = new Date();
          dateObj.setHours(hours, minutes, 0, 0);
          return new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' }).format(dateObj);
        }
      }
    }

    let dateObj: Date;
    if (value instanceof Date) {
      dateObj = value;
    } else if (typeof value === "string" || typeof value === "number") {
      dateObj = new Date(value);
    } else if (isOldFirestoreTimestamp(value)) {
      dateObj = new Date(value._seconds * 1000);
    } else if (isFirestoreTimestamp(value)) {
      dateObj = new Date(value.seconds * 1000);
    } else {
      return "Invalid date/time";
    }

    if (isNaN(dateObj.getTime())) {
      return "Invalid date/time";
    }

    if (type?.toLowerCase() === "date") {
      return dateObj.toLocaleDateString();
    } else if (type?.toLowerCase() === "time") {
      return new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' }).format(dateObj);
    } else {
      return new Intl.DateTimeFormat(undefined, { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' }).format(dateObj);
    }
  } catch {
    return "Invalid date/time";
  }
}

